<template>
  <v-container class="custom-container">
    <v-row dense>
      <v-col cols="12">
        <v-card
          class="pa-5 live-trade-details-card"
          elevation="0"
          :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
        >
          <v-row class="no-gutters align-center">
            <v-col cols="12" sm="6" md="8" lg="9">
              <v-text-field
                v-model="search"
                @input="debounceSearch"
                prepend-icon="mdi-magnify"
                label="Search trade number ..."
                single-line
                solo
                hide-details
                class="mt-0"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <ul class="mt-0">
                <li>
                  <span class="">Total Count:</span>
                  <span>{{ creditSummaries.totalRecords }}</span>
                </li>

                <li>
                  <span class="text--green">Total Credit Back:</span>
                  <span>${{ creditSummaries.totalCredit }}</span>
                </li>
              </ul>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="12">
              <v-card
                class="pa-0 rounded-0 elevation-0"
                :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
              >
                <v-sheet
                  class="transactionTable depositTabTable registerUserTable"
                  :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
                >
                  <v-data-table :headers="headers" :items="autoCreditBack" :server-items-length="pagination?.total || 10"
                    :options.sync="options" :loading="isLoading" :items-per-page="options.itemsPerPage" :footer-props="{
                      'items-per-page-options': [10, 25, 50, 100],
                      'items-per-page-text': 'Rows per page:'
                    }" @update:options="handleOptionsChange" disable-sort>

                    <template v-slot:item.sl="{ index, item }">
                      {{ index + 1 }}
                    </template>

                    <template v-slot:item.nameLink="{ item }">
                      <router-link class="text-capitalize text--ash"
                        :to="`/registered-user-details/${item?.client_account_id}`">
                        {{ `${item?.accounts?.fname} ${item?.accounts?.lname}` }}
                      </router-link>
                    </template>
                    
                    <template v-slot:item.email="{ item }">
                      <v-tooltip top color="#000">
                        <template v-slot:activator="{ on }">
                          <v-btn plain title x-small v-on="on" @click="copyText(item)" style="text-transform: none">
                            {{ obfuscateAnyEmail(item?.accounts?.email) }}
                            <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">{{
                              copiedStates[item.id]
                                ? "mdi mdi-check"
                                : "mdi-content-copy"
                            }}</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ item?.accounts?.email }}</span>
                      </v-tooltip>
                    </template>

                    <template v-slot:item.TradingAccount="{ item }">
                      {{ `${item.trading_account_no} (${item?.tradingaccounttypes.account_type_display})` }}
                    </template>
                    <template v-slot:item.CreditView="{ item }">
                      {{ `$${parseFloat(item.credit).toFixed(2)}` }}
                    </template>
                    <template v-slot:item.EquityView="{ item }">
                      {{ `$${parseFloat(item.equity).toFixed(2)}` }}
                    </template>
                    <template v-slot:item.BalanceView="{ item }">
                      {{ `$${parseFloat(item.balance).toFixed(2)}` }}
                    </template>
                    <template v-slot:item.dateAndTime="{ item }">
                      {{ item?.created_at }}
                    </template>

                  </v-data-table>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { RMSSETTINGS__ACTIONS } from '@/store/action-types';
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";

export default {
  data() {
    return {
      search: "",
      searchTimeout: null,
      copiedStates: {},
      isLoading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      headers: [
        { text: "SL", value: "sl" },
        { text: "Name & ID", value: "nameLink" },
        { text: "Email", value: "email" },
        { text: "Trading Acc", value: "TradingAccount" },
        { text: "Credit", value: "CreditView" },
        { text: "Equity", value: "EquityView" },
        { text: "Balance", value: "BalanceView" },
        { text: "Date and Time", value: "dateAndTime" },
      ],
    };
  },
  computed: {
    ...mapState("rmssettings", [
      "autoCreditBack",
      "pagination",
      "creditSummaries"
    ]),
    ...mapState("admins", ["loggedAdmin"]),
  },

  methods: {
    ...mapActions("rmssettings", [ RMSSETTINGS__ACTIONS.AUTOCREDITBACK ]),

    formattedAllNumber(num) {
      return formatNumber(num || 0);
    },

    async fetchData() {
      try {
        this.isLoading = true
        const params = {
          page: this.options.page || 1,
          limit: this.options.itemsPerPage || 10,
          search: this.search
        };

        await this[RMSSETTINGS__ACTIONS.AUTOCREDITBACK](params);

      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },

    async handleSearch(value) {
      await this.fetchData();
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.handleSearch();
      }, 500);
    },

    copyText(item) {
      navigator.clipboard.writeText(item.email);
      this.$set(this.copiedStates, item.id, true);
      setTimeout(() => {
        this.$set(this.copiedStates, item.id, false);
      }, 1000);
    },

    obfuscateAnyEmail(email) {
      return obfuscateEmail(email)
    },

    handleOptionsChange(options) {
      this.fetchData();
    },
  },
  async created() {
    await this.fetchData();
  },
};
</script>
